// extracted by mini-css-extract-plugin
export default {"root":"promotionsLink-module__root--JkFvr","svg":"promotionsLink-module__svg--RIWnK"};